(() => {
  // Shopify Liquid and Ajax prices are already in the presentment currency.
  // Format only: saved browser currencies and exchange rates must not change them.
  const config = window.theme?.displayCurrencyConfig || {};
  const currency = config.currency || window.Shopify?.currency?.active || "USD";
  const formatter = new Intl.NumberFormat(config.locale || document.documentElement.lang || "en", {
    style: "currency", currency, currencyDisplay: "narrowSymbol",
  });
  const service = {
    currency,
    format(cents) {
      const amount = Number(cents) / 100;
      if (!Number.isFinite(amount)) return "";
      const label = formatter.formatToParts(amount)
        .map(part => part.type === "literal" ? part.value.replace(/ /g, "\u00A0") : part.value)
        .join("");
      return label.includes(currency) ? label : `${label}\u00A0${currency}`;
    },
    formatAll(root = document) {
      root.querySelectorAll("[data-display-money][data-cents]").forEach(element => {
        element.textContent = service.format(Number(element.dataset.cents));
      });
      root.querySelectorAll("[data-display-currency-code]").forEach(element => {
        element.textContent = currency;
      });
      document.documentElement.dataset.displayCurrency = currency;
    },
  };
  window.theme.displayCurrency = service;
  window.theme.formatMoney = cents => `<span data-display-money data-cents="${Number(cents)}">${service.format(cents)}</span>`;
  // Compatibility hook for Ajax cards, cart, variant pickers and the size guide.
  window.theme.reconvertPrices = () => service.formatAll();

  class DisplayCurrencySelector extends HTMLElement {
    connectedCallback() {
      const select = this.querySelector("[data-market-country-select]");
      if (!select || select.dataset.ready === "true") return;
      select.dataset.ready = "true";
      select.addEventListener("change", () => {
        if (select.value === config.country) return;
        const form = select.closest("form");
        if (!form) return;
        const returnTo = form.querySelector('[name="return_to"]');
        if (returnTo) returnTo.value = window.location.pathname + window.location.search + window.location.hash;
        form.requestSubmit();
      });
    }
  }
  if (!customElements.get("display-currency-selector")) {
    customElements.define("display-currency-selector", DisplayCurrencySelector);
  }
  service.formatAll();
})();
